import VehicleCard from '../VehicleCard';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    vehPhotoList: state.Vehicles.vehPhotoList,
    theme: state.Framework.theme,
    newVehicleMileage: state.NewVehicle.NewVehicle?.estMileage,
    Itype: state.Framework.ImageServerType,
    locale: state.Framework.locale,
});

export default connect(
    mapStateToProps,
    null,
)(VehicleCard);